"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    TeachingPopoverTrigger: function() {
        return _index.TeachingPopoverTrigger;
    },
    renderTeachingPopoverTrigger_unstable: function() {
        return _index.renderTeachingPopoverTrigger_unstable;
    },
    useTeachingPopoverTrigger_unstable: function() {
        return _index.useTeachingPopoverTrigger_unstable;
    }
});
const _index = require("./components/TeachingPopoverTrigger/index");
